module.exports = __webpack_public_path__ + "static/media/pure-natural-input.74f1b21d.svg";